module.exports = __webpack_public_path__ + "img/sec1_img5.913552fc.jpg";